import { ActionTypes } from '../../constants/ActionTypes';
import { IMemoReducer } from '../../interfaces/Memo';

const INIT_STATE: IMemoReducer = {
  letterNotes: [],
  letterNoteToAdd: {
    letterCode: '',
    note: '',
  },
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_LETTER_NOTE: {
      return {
        ...state,
        params: action.payload,
      };
    }

    case ActionTypes.FETCH_LETTER_NOTE_SUCCESS: {
      return {
        ...state,
        letterNotes: action.payload,
      };
    }

    case ActionTypes.ADD_LETTER_NOTE: {
      const model = {
        letterCode: action.payload.letterCode,
        note: action.payload.note,
      };
      return {
        ...state,
        model,
      };
    }

    case ActionTypes.ADD_LETTER_NOTE_SUCCESS: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};
